/*eslint-disable*/
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FormHelperText,
  CircularProgress,
  Checkbox,
  Button,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Dialog,
  FormControlLabel,
  Typography,
} from '@material-ui/core';
import useAuth from '../../hooks/useAuth';
import NotificationChangePassword from './NotificationForgotPassword';
import { useStyles } from './style';
import { useState } from 'react';

const VerifyEmail: any = ({ handleClose }) => {
  const { verifyEmail } = useAuth() as any;
  const { t } = useTranslation('account');
  const [isModalOpened, setModalOpened] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const classes = useStyles();
  const [isProvider, setIsProvider] = useState(false);

  const handleProvider = () => {
    setIsProvider(!isProvider);
  };

  // Functions to show create's modal
  const handleShowModal = (): void => {
    setModalOpened(true);
  };

  const handleHideModal = (): void => {
    setModalOpened(false);
  };

  return (
    <>
      <Formik
        initialValues={{
          email: '',
          ruc: '',
          submit: null,
        }}
        validationSchema={Yup.object().shape(
          {
            email: Yup.string().when('ruc', {
              is: (ruc) => !ruc || ruc.length === 0,
              then: Yup.string()
                .email(t('validation.validEmail'))
                .max(255)
                .required(t('validation.fieldRequired')),
            }),
            ruc: Yup.string().when('email', {
              is: (email) => !email || email.length === 0,
              then: Yup.string().required(t('validation.fieldRequired')),
            }),
          },
          [['email', 'ruc']]
        )}
        onSubmit={async (
          values,
          { resetForm, setErrors, setStatus, setSubmitting }
        ) => {
          try {
            if (isProvider === true) {
              await verifyEmail(values.ruc, isProvider);
              setEmail(values.ruc);
              //await login(values.ruc, values.password, isProvider);
            } else {
              await verifyEmail(values.email, isProvider);
              setEmail(values.email);
              //await login(values.email, values.password);
            }
            //setEmail(values.email);
            //await verifyEmail(values.email);
            resetForm();
            setStatus({ success: true });
            setSubmitting(false);
            handleShowModal();
          } catch (err) {
            console.error(err);
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <>
            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={5} padding={10}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit}>
                <DialogTitle sx={{ textAlign: 'center' }}>
                  <span className={classes.dialogTitle}>
                    {t('login.recoverAccount')}
                  </span>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    sx={{ textAlign: 'center', color: '#42526E' }}
                  >
                    {!isProvider ? (
                      <Typography>
                        {t('forgotPassword.description1')}&nbsp;<b>{t('forgotPassword.description2')}</b>
                        &nbsp;{t('forgotPassword.description3')}
                      </Typography>
                    ) : (
                      <Typography>
                        {t('forgotPassword.descriptionProveedor1')}&nbsp;<b>{t('forgotPassword.descriptionProveedor2')}</b>
                        &nbsp;{t('forgotPassword.descriptionProveedor2')}
                      </Typography>
                    )}
                  </DialogContentText>
                  <Box py={5}>
                    {isProvider === false ? (
                      <TextField
                        autoFocus
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        label={t('login.email')}
                        margin="normal"
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="email"
                        value={values.email}
                        variant="outlined"
                      />
                    ) : (
                      <TextField
                        autoFocus
                        error={Boolean(touched.ruc && errors.ruc)}
                        fullWidth
                        helperText={touched.ruc && errors.ruc}
                        label="RUC"
                        margin="normal"
                        name="ruc"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.ruc}
                        variant="outlined"
                      />
                    )}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isProvider}
                          onChange={handleProvider}
                          name="checkedB"
                          color="primary"
                        />
                      }
                      label={t('forgotPassword.checkbox')}
                    />
                  </Box>
                  {errors.submit && (
                    <Box mt={3}>
                      <FormHelperText error>{errors.submit}</FormHelperText>
                    </Box>
                  )}
                </DialogContent>
                <DialogActions
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Box my={1}>
                    <Grid container sx={{ textAlign: 'center' }} spacing={1}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.button}
                          fullWidth
                          type="submit"
                          variant="contained"
                          disabled={isSubmitting}
                        >
                          {t('login.recoverAccount')}
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Button onClick={handleClose} color="primary">
                          {t('forgotPassword.cancel')}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </DialogActions>
              </form>
            )}
          </>
        )}
      </Formik>
      <NotificationChangePassword
        open={isModalOpened}
        onClose={handleHideModal}
        parentClose={handleClose}
        email={email}
      />
    </>
  );
};

export default VerifyEmail;
